export default __webpack_public_path__ + "static/media/5229cd45e3a9966f.e4222eaf36c8552108e925cee29e4020.svg";